import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  globalDDLDatePeriod: {},
  globalDDLDatePeriodDB: {}
}

const globalDDLSlices = createSlice({
  name: 'globalDDL',
  initialState,
  reducers: {
    setGlobalDDLDatePeriod: (state, action) => {
      state.globalDDLDatePeriod = action.payload
    },
    setGlobalDDLDatePeriodDB: (state, action) => {
      state.globalDDLDatePeriodDB = action.payload
    }
  }
});

export const { setGlobalDDLDatePeriod, setGlobalDDLDatePeriodDB } = globalDDLSlices.actions;

export default globalDDLSlices.reducer;